// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import AdminOfferManager from "../../components/dashboard/AdminOfferManager";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <AdminOfferManager />
    </DashboardLayout>
  );
}
